import { useEffect } from 'react';

export const useBrowserTabLogin = (history) => {
  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === 'token' && event.newValue) window.location.reload();
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);
};
